<script>
  import {mapActions, mapGetters} from 'vuex'
  import DateSelect from './DateSelect.vue'
  import Labl from "@/components/Labl";

  let initialState = function () {
    return {
      patientName: null,
      patientSurname: null,
      patientBirthDate: null,
      patientBirthPlace: null,
      patientFcode: null,
      patientGender: "M",
      applicantPhone: null,
      applicantEmail: null,
      applicantContact: null,
      day: null,
      month: null,
      year: null,
    }
  };

  export default {

    name: 'Appointment',

    props: ['isCompleted', 'isReady'],

    components: {
      Labl,
      DateSelect
    },

    computed: {
      ...mapGetters(['getHourlyChoices', 'getLabel', 'getPatientData']),
      fullName: function () {
        return this.getPatientData.patientName + " " + this.getPatientData.patientSurname
      }
    },

    mounted: function () {
      let ctx = this;
      this.eventHub.$on("resetAll", () => {
        ctx.reset(true);
      });
    },

    methods: {
      ...mapActions(['completeStep', 'setPatientData', 'resetStepsTo']),

      proceed: function () {
        this.$validator.validate().then(valid => {
          if (valid) {
            let patientData = {
              patientName: this.patientName,
              patientSurname: this.patientSurname,
              patientBirthDate: this.patientBirthDate,
              patientBirthPlace: this.patientBirthPlace,
              patientFcode: this.patientFcode,
              patientGender: this.patientGender,
              applicantPhone: this.applicantPhone,
              applicantEmail: this.applicantEmail,
              applicantContact: this.applicantContact,
            };
            this.setPatientData(patientData);
            this.$analytics.pushEvent("paziente:step-completed");
            this.completeStep(3);
          }
        });
      },

      // GSD-586 change reset function for not delete patientData
      reset: function (force) {
        if (!force) {
          this.resetStepsTo(3);
        }
      }
    },

    data: function () {
      return initialState()
    }
  }
</script>

<template>
  <div class="appointment wrap-step" :class="{uncompleted : !isReady, checked : isCompleted}">
    <h4>
      <Msg id="ospedali.form.appointment.title"/>
    </h4>

    <div v-if="!isCompleted && isReady">
      <div role="group" class="fieldset">
        <legend>{{getLabel('ospedali.form.appointment.groupfield.patient.title')}}</legend>

        <div>
          <Labl id="ospedali.form.appointment.patient.name.label" for="id_patient_name"/>
          <input id="id_patient_name" v-model="patientName" data-vv-as=" " name="patientName" v-validate.disable="'required'" type="text"
                 maxlength="50"/>
          <span class="error">{{ errors.first('patientName') }}</span>
        </div>

        <div>
          <Labl id="ospedali.form.appointment.patient.surname.label" for="id_patient_surname"/>
          <input id="id_patient_surname" v-model="patientSurname" data-vv-as=" " name="patientSurname" v-validate.disable="'required'" maxlength="50"
                 type="text"/>
          <span class="error">{{ errors.first('patientSurname') }}</span>
        </div>

        <div>
          <Msg :id="'ospedali.form.appointment.patient.birthday.label'"/>
          <DateSelect :selDay="day" @setDay="day=$event" :selMonth="month" @setMonth="month=$event" :selYear="year" @setYear="year=$event"
                     :class="{ invalid: errors.has('patientBirthDate')}"  data-vv-as=" "
                     v-model="patientBirthDate" :name="'patientBirthDate'"
                     v-validate.disable="'required|date_format:dd/MM/yyyy|before:'+ new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/[^ -~]/g,'') + ',true'"/>
          <span class="error">{{ errors.first('patientBirthDate') }}</span>
        </div>

        <div>
          <Labl id="ospedali.form.appointment.patient.birthplace.label" for="id_patient_birthplace"/>
          <input id="id_patient_birthplace" v-model="patientBirthPlace" data-vv-as=" " name="patientBirthPlace" type="text"
                 v-validate.disable="'required'" maxlength="25"/>
          <span class="error">{{ errors.first('patientBirthPlace') }}</span>
        </div>

        <div>
          <Labl id="ospedali.form.appointment.patient.fiscalCode.label" for="id_patient_fiscalCode"/>
          <input id="id_patient_fiscalCode" v-model="patientFcode" data-vv-as=" " name="patientFcode" type="text"
                 v-validate.disable="{ required: true, regex: /^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z][0-9]{3}[A-Za-z]$/ }"
                 maxlength="16"/>
          <span class="error">{{ errors.first('patientFcode') }}</span>
        </div>
        <div class="radio" :class="{ padded: errors.has('patientFcode')}">
          <Msg id="ospedali.form.appointment.patient.gender.label"/>
          <div>
            <input type="radio" name="patientGender" id="male" value="M" v-model="patientGender">
            <label for="male">{{getLabel('ospedali.form.appointment.patient.gender.m')}}</label>
          </div>
          <div>
            <input type="radio" name="patientGender" id="female" value="F" v-model="patientGender">
            <label for="female">{{getLabel('ospedali.form.appointment.patient.gender.f')}}</label>
          </div>
        </div>

      </div>

      <div role="group" class="fieldset">
        <legend>{{getLabel('ospedali.form.appointment.groupfield.contact.title')}}</legend>

        <div>
          <Labl id="ospedali.form.appointment.contact.phone.label" for="id_patient_phone"/>
          <input id="id_patient_phone" v-model="applicantPhone" data-vv-as=" " name="applicantPhone" v-validate.disable="'required'" maxlength="20"/>
          <span class="error">{{ errors.first('applicantPhone') }}</span>
        </div>

        <div>
          <Labl id="ospedali.form.appointment.contact.email.label" for="id_patient_email"/>
          <input id="id_patient_email" v-model="applicantEmail" data-vv-as=" " name="applicantEmail" v-validate.disable="'required|email'" maxlength="50"/>
          <span class="error">{{ errors.first('applicantEmail') }}</span>
        </div>

        <div>
          <Msg id="ospedali.form.appointment.contact.hour.label"/>
          <v-select v-model="applicantContact" data-vv-as=" " name="applicantContact"
                    :placeholder="getLabel('ospedali.form.appointment.contact.hour.placeholder')"
                    :searchable="false" v-validate.disable="'required'" :options="getHourlyChoices"
                    :class="{ invalid: errors.has('applicantContact')}" label="label">
          </v-select>
          <span class="error">{{ errors.first('applicantContact') }}</span>
        </div>
      </div>

      <div class="wrap-main-cta">
        <button @click="proceed()" class="button-primary">
          {{getLabel('ospedali.form.button.proceeed')}}
        </button>
      </div>
    </div>

    <div v-else-if="isCompleted">
      <span> {{fullName}} </span>
      <button @click="reset(false)" class="button-text">{{getLabel("ospedali.form.button.modify")}}</button>
    </div>

  </div>
</template>